module.exports = __webpack_public_path__ + "static/media/party.9f1d0b45.png";